// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"e8cf43da","156":"0af0868c"}[chunkId] + ".chunk.css";
};